import PropTypes from "prop-types";
import React from "react";

import {Error} from "../api";


const getErrorMessage = (dataError) => {
  if (dataError) {
    switch (true) {
      case dataError.status === Error.PAGE_NOT_FOUND:
        return `Страница не найдена.`;

      default:
        return `Ошибка запроса.`;
    }
  }

  return null;
};


export const ErrorPage = (props) => {
  const {dataError} = props;

  const errorMessage = getErrorMessage(dataError);

  return (
    <main className="main">
      <div className="main__sidebar">
        <section className="sidebar"></section>
      </div>
      <div className="main__page-content">
        <section className="page-content">
          <header className="header" style={{paddingTop: `20%`}}>
            <h1 className="header__title">{errorMessage}</h1>
          </header>
        </section>
      </div>
    </main>
  );
};


ErrorPage.propTypes = {
  dataError: PropTypes.object,
};
